import { useMemo } from 'react';

import { Dotdotdot } from '@hivebrite/design-system/Dotdotdot';

import type { Event } from 'hb-react/shared/apps/Events/types';
import type { TimeZoneConfiguration } from 'hb-react/types/timeZoneConfiguration';

import getDateStr from './utils/getDateStr';

const EventDate = ({
  dateString,
  event,
  withIcon = false,
  clamp,
  timezoneConfiguration,
  as = 'div',
}: {
  dateString?: string;
  event: Pick<Event, 'start_date' | 'end_date' | 'timezone'>;
  withIcon?: boolean;
  clamp?: number;
  timezoneConfiguration?: TimeZoneConfiguration;
  as?: React.ElementType;
}) => {
  const { currentUserTimezone, eventDatesInUserTimezone } =
    timezoneConfiguration || {};

  const {
    start_date: startDate,
    end_date: endDate,
    timezone: eventTimeZone,
  } = event;

  const targetTimeZone = eventDatesInUserTimezone
    ? currentUserTimezone
    : eventTimeZone;

  const dateStr = useMemo(
    () =>
      dateString ||
      getDateStr({ startDate, endDate, timezone: targetTimeZone }),
    [dateString, startDate, endDate, targetTimeZone],
  );

  const dateContent = (
    <>
      {withIcon && <i className="icon-clock soft-half--right" />}
      {dateStr}
    </>
  );

  const Component = as;

  return clamp ? (
    <Component title={dateStr}>
      <Dotdotdot clamp={clamp}>{dateContent}</Dotdotdot>
    </Component>
  ) : (
    <Component>{dateContent}</Component>
  );
};

export default EventDate;
